import React from 'react'
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded'
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    ListItem,
    List,
    ListItemText,
    Button,
    ListItemIcon,
    CircularProgress,
} from '@mui/material'
import Typography from '@mui/material/Typography'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded'
import ExitToAppRoundedIcon from '@mui/icons-material/ExitToAppRounded'
import { Link } from 'react-router-dom'
import useStyles from './_styles'
import useCurrentUser from '../../../hooks/useCurrentUser'
import { HeaderUserMenuContentProps } from './_props'
import useLogout from '../../../hooks/useLogout'
import { useUserMenu } from '../../../hooks/useUserMenu'

const HeaderUserMenuContent = ({ handleClose }: HeaderUserMenuContentProps) => {
    const { logout, loading } = useLogout()
    const classes = useStyles()
    const currentUser = useCurrentUser()
    const [expanded, setExpanded] = React.useState<string | null>(null)
    const helpCenterUrl = 'https://aide.toktokdoc.com'

    const handleChange = (panelId: string) => {
        setExpanded(expanded === panelId ? null : panelId)
    }

    const menuEntries = useUserMenu({
        helpCenterUrl,
        iconClass: classes.HeaderUserMenuItemIcon,
    })

    return (
        <div className={classes.HeaderUserMenuContent}>
            <div className={classes.HeaderUserMenuUser}>
                <AccountCircleRoundedIcon />
                <Typography>{currentUser.fullName}</Typography>
            </div>
            <div className={classes.HeaderUserMenuItems}>
                {menuEntries.map((entry, index) => {
                    const { title, options } = entry

                    const id = `panel${index}`
                    return (
                        <React.Fragment key={title}>
                            <Accordion
                                expanded={expanded === id}
                                onChange={() => handleChange(id)}
                                className={classes.HeaderUserMenuItemsGroup}
                            >
                                <AccordionSummary
                                    expandIcon={<ArrowDropDownRoundedIcon />}
                                    aria-controls={`${id}bh-content`}
                                    id={`${id}bh-header`}
                                    className={classes.HeaderUserMenuItemsGroupTitle}
                                >
                                    <Typography className={classes.HeaderUserMenuItemsGroupTitleText}>
                                        {title}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails className={classes.HeaderUserMenuItemsGroupContent}>
                                    <List className={classes.HeaderUserMenuItemsGroupContentList}>
                                        {options.map((option) => {
                                            if (option.hidden) {
                                                return null
                                            }

                                            const handleClick = () => {
                                                option.action?.()
                                                handleClose()
                                            }

                                            return (
                                                <ListItem
                                                    key={option.label}
                                                    component={option.to ? Link : 'li'}
                                                    target={option.to?.includes(helpCenterUrl) ? '_blank' : '_self'}
                                                    className={classes.HeaderUserMenuItem}
                                                    onClick={handleClick}
                                                    to={option.to}
                                                    data-cy={`dataCy_${option.to
                                                        ?.replace('/', '')
                                                        .replaceAll('/', '-')}`}
                                                >
                                                    <ListItemText primary={option.label} />
                                                    {option.icon && <ListItemIcon>{option.icon}</ListItemIcon>}
                                                </ListItem>
                                            )
                                        })}
                                    </List>
                                </AccordionDetails>
                            </Accordion>
                            <div className={classes.HeaderUserMenuItemsGroupSeparator} />
                        </React.Fragment>
                    )
                })}
            </div>
            <div className={classes.HeaderUserMenuLogout}>
                <Button
                    variant="contained"
                    disableElevation
                    className={classes.HeaderUserMenuLogoutButton}
                    onClick={() => {
                        logout()
                    }}
                    startIcon={loading ? <CircularProgress color="inherit" /> : <ExitToAppRoundedIcon />}
                >
                    {loading ? '' : 'Déconnexion'}
                </Button>
            </div>
        </div>
    )
}

export default HeaderUserMenuContent
